moya.usedcars = (function() {
	var subBrands = null,
		urlParams = null,
		getParams = null,
		carousel = null;

	return {
		carousel: carousel,
		initCarousel: function() {
			carousel = new Swiper ('.usedcars__carousel', {
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				pagination: '.swiper-pagination',
				paginationType: 'custom',
				paginationCustomRender: function (swiper, current, total) {
					var p = '';
					$.each(swiper.slides, function(index, slide) {
						var srcImage = $(slide).find('.carousel__image img'),
							destImage = new Image(),
							classCurrent = '';

						destImage.src = $(srcImage).attr('src').replace('full', 'thumb');

						if (current === index+1) {
							classCurrent = ' active';
						}

						p += '<div class="swiper-pagination-page'+classCurrent+'" data-index="'+index+'"><img src="'+destImage.src+'" /></div>';
					});

					return p;
				},
				loop: false,
				lazyLoading: true,
				slideToClickedSlide: true,
				autoplay: 5000,
				speed: 1000,
			});

			$('.swiper-pagination').on('click', 'div', function() {
				var $page = $(this);
				carousel.slideTo($page.attr('data-index'), 500, false);
			});
		},
		initSubBrands: function(data) {
			subBrands = data;

			var $brand = $('#brand');
			$brand.change(function(){
				var v = $(this).val();
				moya.usedcars.setSubBrands(v);
			});

			moya.usedcars.initQueryParams();
			var u = moya.usedcars.getParams;

			if (u && u["brand"]) {
				$brand.val(u["brand"]);
				moya.usedcars.setSubBrands(u["brand"]);
			}
			var $subbrand = $('#subbrand');

			/*
			if(subBrands && !u) {
				console.log(subBrands[$brand.val()]);
				moya.usedcars.setSubBrands($brand.val());
			}*/
			if (u && u["subbrand"]) {
				$subbrand.val(u["subbrand"]);
			}
			else {
				$subbrand.val('');
			}
			$subbrand.change(function(){
				var $name = $('#searchForm').find('#name');
				var v = $(this).val();
				if (v) {
					$name.removeAttr('disabled');
				}
				else {
					$name.attr('disabled','disabled');
				}
			}).trigger('change');
		},
		setSubBrands: function(v) {
			var s = $('#subbrand');
			s.empty();
			if (subBrands[v]) {
				$.each(subBrands[v], function (kk, vv) {
					s.append("<option value=\"" + vv + "\">" + vv + "</option>");
				});
				s.prepend("<option value=\"\">--</option>");
				s.wrapInner("<optgroup id=\"subbrand-optgroup-\" label />");
				s.find('option:first').attr('selected','selected');
			}
			s.trigger('change');
		},
		initQueryParams: function ()
		{
			urlParams = {};
			var e,
				a = /\+/g,  // Regex for replacing addition symbol with a space
				r = /([^&=]+)=?([^&]*)/g,
				d = function (s) { return decodeURIComponent(unescape(s.replace(a, " "))); },
				q = window.location.search.substring(1);

			while (e = r.exec(q)) {
				//console.log(q);
				urlParams[d(e[1])] = d(e[2]);
			}
			urlParams = urlParams;
			return urlParams;
		},
		initSubmitButton: function(id) {
			$('#'+id).removeAttr('name');
			$('#dg_extra #elm_sequencenumber').after('<a id="dg_reset" class="clear" href="#" onclick="moya.usedcars.clearForm()">Hreinsa</a><br />');
		},
			iconUrl: function(href) {
			//var b = href.match(/\/([^\/]+)\/([^\/]+)?$/);
			var b = href.replace(/\/$/, '').split('/');
			var device = b.pop();
			var action = b.pop();
			var r = '/_/' + moya.division + '/usedcars/index/' + action + '/' + device;
			return r;
		},
		initDeviceIcons: function() {
			$('.iconlist a.facebook').click(function(e) {
				alert('Bimmi reddar')
			});
		},
		initImages: function() {
			$('#usedcars .images img').hover(function(){
				var main = $('#usedcars .mainImage img');
				var u = this.src.replace('thumb', 'full');
				main.get(0).src = u;
			}).click(function() {
				return false;
			});
		},
		clearForm: function() {
			$('#searchForm select').val('');
			$('#searchForm input[type="checkbox"]').removeAttr('checked');
			$('#searchForm .elm').removeClass('selected');
			$('#searchForm input#name,#searchForm #sequencenumber').val('');
		},
		searchFormExtraToggle: function() {
			var extra = $('#dg_extra');
			var eLink = $('#dg_extraLink');
			var strs = { toHide: "F\xe6rri m\xf6guleikar", toShow: "Fleiri m\xf6guleikar" };

			if (eLink.length == 0) {
				$('#dg_extra').after('<a id="dg_extraLink" href="#" onclick="moya.usedcars.searchFormExtraToggle();return false;">TEMPL</a>');
				eLink = $('#dg_extraLink');
			}

			if (extra.hasClass('close')) {
				// Showing extra
				extra.removeClass('close');
				eLink.text(strs['toHide']);
			}
			else {
				extra.addClass('close');
				eLink.text(strs['toShow']);
			}
		}
	}
})();
